import styled from 'styled-components';
import COLORS from '../../constants/colors.js';

const StyledLineDivider = styled.span `
    display: inline-block;
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => (margin ? margin : "1px 0")};
    border-bottom-width: ${({ borderWidth }) => borderWidth ? `${borderWidth}px` : "1px"};
    border-bottom-color: ${({ color }) => (color ? color : COLORS.GREY_300)};
    border-bottom-style: ${({ styleType }) => styleType ? styleType : "dashed"};
`;
const StyledLinearLineDivider = styled.div `
    height: ${({ linearGradientHeight }) => `${linearGradientHeight ? linearGradientHeight + "px" : "2px"}`};
    background: ${({ color, linearGradientDirect }) => linearGradientDirect === "toLeft"
    ? `linear-gradient(to left, #fff, ${color ? color : COLORS.GREY_200})`
    : linearGradientDirect === "toRight"
        ? `linear-gradient(to left, ${color ? color : COLORS.GREY_200}, #fff)`
        : `linear-gradient(to left, #fff, ${color ? color : COLORS.GREY_200}, #fff)`};
    width: ${({ width }) => (width ? width : "100%")};
    margin: ${({ margin }) => (margin ? margin : "1px 0")};
`;

export { StyledLineDivider, StyledLinearLineDivider };
//# sourceMappingURL=LineDivider.styles.js.map
